export const getPartialEmail = (email: string) => {
  return email.replace(
    /(^.{3})(.*)(@{1})(.+$)/,
    function (g0: string, g1: string, g2: string, g3: string, g4: string) {
      return `${g1}${"*".repeat(g2.length)}${g3}${g4}`;
    }
  );
};

export const getPartialCPF = (cpf: string) => {
  return cpf.replace(
    /(^.{3})(.{3})(.{3})(.{2})/,
    function (g0, g1, g2, g3, g4) {
      return `${g1}.${"X".repeat(g2.length)}.${"X".repeat(g3.length)}-${g4}`;
    }
  );
};
export const formatCPF = (cpf: string) =>
  cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
export const formatRG = (rg: string) =>
  rg.replace(/(\d{1,2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
